export const calculateValueFromPercentage = (oneHundredPercent: number, percent: number): number => {
  if (oneHundredPercent === 0) {
    return 0;
  }

  return Math.round((oneHundredPercent / 100) * percent);
};
